<template>
  <HeroSection
    v-if="page"
    :title="page.title"
    :bg-src="page.image"
    :bg-position="page.imagePosition"
  >
    <p>{{ page.description }}</p>

    <div class="flex justify-center gap-1 pt-10 pb-20">
      <UButton :to="page?.ctaTo ?? '/book'" variant="solid" size="lg">Book</UButton>
      <UButton to="#reviews" variant="link" color="white" size="lg">Reviews</UButton>
    </div>
  </HeroSection>

  <NuxtPage />

  <ContentReviewsSection />

  <Footer />
</template>

<script setup lang="ts">
const $route = useRoute()
const pages = useServicesPages()

const { data: page } = await useAsyncData($route.path, async () => {
  if ($route.path === '/services') {
    navigateTo('/#services')
    return
  }
  const page = pages.find(page => page.to === $route.path)

  if (!page) throw createError(`Page ${$route.path} cannot be found`)
  return page
}, { watch: [() => $route.path] })
</script>
